/**
 * Chatwoot SDK window typings and accessor
 *
 * Declares the global Chatwoot widget API and exposes `getChatwoot()` after
 * `ensureOnboardingChatwoot` injects the SDK script.
 */

export interface ChatwootSDK {
  toggle: (state: 'open' | 'close') => void;
  isOpen: boolean;
  setUser: (identifier: string, user: { email?: string; name?: string; identifier_hash?: string }) => void;
  setCustomAttributes: (attributes: Record<string, string | number | boolean>) => void;
  setConversationCustomAttributes: (attributes: Record<string, string | number | boolean>) => void;
  setLocale: (locale: string) => void;
  reset: () => void;
}

declare global {
  interface Window {
    $chatwoot?: ChatwootSDK;
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    chatwootSettings?: {
      hideMessageBubble?: boolean;
      position?: 'left' | 'right';
      locale?: string;
      type?: 'standard' | 'expanded_bubble';
      launcherTitle?: string;
    };
  }
}

/**
 * Returns the live Chatwoot widget instance when the SDK has finished loading.
 *
 * @return {Object | null} Chatwoot SDK handle or null before ready.
 */
export const getChatwoot = (): ChatwootSDK | null => {
  return window.$chatwoot ?? null;
};
